import { Injectable } from '@angular/core';
import { ApplicationUserStore } from './application-user.store';
import { ApplicationUserQuery } from './application-user.query';
import { BaseFacade } from '../base/base.facade';
import { ApplicationUserService } from './application-user.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';

@Injectable({ providedIn: 'root' })
export class ApplicationUserFacade extends BaseFacade {
  constructor(
    userService: ApplicationUserService,
    userStore: ApplicationUserStore,
    userQuery: ApplicationUserQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(userService,
      userStore,
      userQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade('application-users'),
      translateService,
      'application-users-facade'
      );
  }
}
